"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

const references = __importStar(require("../../../common/casualReferences"));

const dayjs_1 = require("../../../utils/dayjs");

const dayjs_2 = __importDefault(require("dayjs"));

const constants_1 = require("../constants");

const PATTERN = new RegExp(`(сейчас|прошлым\\s*вечером|прошлой\\s*ночью|следующей\\s*ночью|сегодня\\s*ночью|этой\\s*ночью|ночью|этим утром|утром|утра|в\\s*полдень|вечером|вечера|в\\s*полночь)` + `${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);

class RUCasualTimeParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
  patternLeftBoundary() {
    return constants_1.REGEX_PARTS.leftBoundary;
  }

  innerPattern() {
    return PATTERN;
  }

  innerExtract(context, match) {
    let targetDate = dayjs_2.default(context.refDate);
    const lowerText = match[0].toLowerCase();
    const component = context.createParsingComponents();

    if (lowerText === "сейчас") {
      return references.now(context.reference);
    }

    if (lowerText === "вечером" || lowerText === "вечера") {
      return references.evening(context.reference);
    }

    if (lowerText.endsWith("утром") || lowerText.endsWith("утра")) {
      return references.morning(context.reference);
    }

    if (lowerText.match(/в\s*полдень/)) {
      return references.noon(context.reference);
    }

    if (lowerText.match(/прошлой\s*ночью/)) {
      return references.lastNight(context.reference);
    }

    if (lowerText.match(/прошлым\s*вечером/)) {
      return references.yesterdayEvening(context.reference);
    }

    if (lowerText.match(/следующей\s*ночью/)) {
      const daysToAdd = targetDate.hour() < 22 ? 1 : 2;
      targetDate = targetDate.add(daysToAdd, "day");
      dayjs_1.assignSimilarDate(component, targetDate);
      component.imply("hour", 0);
    }

    if (lowerText.match(/в\s*полночь/) || lowerText.endsWith("ночью")) {
      return references.midnight(context.reference);
    }

    return component;
  }

}

exports.default = RUCasualTimeParser;